import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import request from '../../utils/request';
import Label from './common/label';

const Role = ({ labels, errors, touched }) => {
  const [rolesList, setRolesList] = useState([]);

  useEffect(() => {
    request.get('/roles?page=registration').then(({ data: { roles } }) => {
      setRolesList(roles);
    });
  }, []);

  return (
    <>
      <Label labelName={labels.SELECT_USER_ROLE} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${
          errors.role && touched.role ? 'error' : ''
        }`}
      >
        <Field as="select" name="role" className="select-style">
          <option disabled selected={!(touched && touched.role)} value="">
            {labels.SELECT_OPTION}
          </option>
          {rolesList.map(role => (
            <option value={role.id}>{role.description}</option>
          ))}
        </Field>
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.role}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

Role.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default Role;
